import React, { memo } from 'react';
import { Breadcrumb, BreadcrumbItem } from '../../../../components/navigation/Breadcrumb';

export interface TabularBreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ComponentType<any>;
}

export interface TabularBreadcrumbProps {
  items: TabularBreadcrumbItem[];
  separator?: string | React.ReactNode;
  maxDisplayedItems?: number;
  className?: string;
}

export const TabularBreadcrumb = memo(function TabularBreadcrumb({
  items,
  separator = '/',
  maxDisplayedItems = 0,
  className = ''
}: TabularBreadcrumbProps) {
  // Convert TabularBreadcrumbItem to BreadcrumbItem format
  const convertedItems: BreadcrumbItem[] = items.map(item => ({
    label: item.label,
    href: item.href,
    onClick: item.onClick,
    icon: item.icon ? <item.icon /> : undefined
  }));
  
  return (
    <div className={`tabular-breadcrumb ${className}`}>
      <Breadcrumb
        items={convertedItems}
        separator={separator}
        maxItems={maxDisplayedItems > 0 ? maxDisplayedItems : undefined}
      />
    </div>
  );
});
